import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
    data: null,
    loading: false,
    error: null,
    count: null,
};

export const fetchAllUserSearchesList = createAsyncThunk(
    "fetchAllUserSearchesList",
    async (body) => {
        try {
            const response = await instance.get(
                `/remark/user/user-searches-list?page=${body.page}&search=${body.search}&startDate=${body.startDate}&endDate=${body.endDate}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);


export const UserSearchesSlice = createSlice({
    name: "UserSearchesSlice",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchAllUserSearchesList.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(fetchAllUserSearchesList.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.count = action.payload?.count;
        });
        builder.addCase(fetchAllUserSearchesList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export default UserSearchesSlice.reducer;
